// import { Api } from 'yxt-biz-pc-base';
// const { knglibApi, utilityApi } = Api;
import {
  knglibApi,
  utilityApi
} from 'yxt-biz-pc/packages/api';

// 知识详情
export const getKngInfo = (id) => {
  return knglibApi.get(`/knowledge/detail/${id}?auditFlag=1`);
};

// 获取指定对象下的标签列表
export const getOrgtags = (targetId) => {
  return utilityApi.get(`tagtargets/${targetId}/orgtags`);
};

